
import StoryBlokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import { navThemeControls } from '~/mixins/navigation/themeChangeOnScroll'

export default {
  components: { StoryBlokComponent },
  mixins: [navThemeControls, breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok?.backgroundStyles
      styles.minHeight = this.getBreakpointValue(this.blok.minHeight)

      return styles
    },
    innerStyles() {
      const styles = {}

      styles.paddingTop = this.getBreakpointValue(this.blok.paddingTop)
      styles.paddingBottom = this.getBreakpointValue(this.blok.paddingBottom)

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.setNavThemeChangeOnScroll(this.blok.nav_theme)
      }
      // !this.blok.noRevealAnimation && this.revealAnimation()
    })
  },
  methods: {
    revealAnimation() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // add a media query. When it matches, the associated function will run
      mm.add('(min-width: 1024px)', () => {
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            start: 'top bottom-=10%',
            toggleActions: 'play none none reverse',
            // markers: true,
          },
        })

        // reveal
        tl.from(
          this.$refs.body,
          {
            opacity: 0,
            y: 50,
            scale: 0.9,
            ease: 'back.out(.3)',
            clearProps: 'all',
          },
          '<'
        )
      })
    },
  },
}
